var _path, _rect, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgSuitcase = function SvgSuitcase(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    d: "M2.3 14.3a1 1 0 0 1-.7-.3 1 1 0 0 1-.3-.7v-8c0-.2.1-.5.3-.7s.5-.3.7-.3h3V2.7c0-.3.1-.5.3-.7s.5-.3.7-.3h3.4c.2 0 .5 0 .7.3.2.2.3.4.3.7v1.6h3c.2 0 .5.1.7.3s.3.5.3.7v8c0 .3-.1.5-.3.7a1 1 0 0 1-.7.3zm0-1h11.4v-8H2.3zm4-9h3.4V2.7H6.3z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1.3,
    height: 6.7,
    x: 5.2,
    y: 7.4,
    fill: "inherit",
    rx: 0.7,
    transform: "rotate(-45 5.2 7.4)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1.3,
    height: 6.7,
    x: 6.2,
    y: 12.2,
    fill: "inherit",
    rx: 0.7,
    transform: "rotate(-135 6.2 12.2)"
  })));
};
export default SvgSuitcase;